// extracted by mini-css-extract-plugin
export var paginationContainer = "_76-0";